import { render, staticRenderFns } from "./ServiceRequisition.vue?vue&type=template&id=3c13b806&scoped=true"
import script from "./ServiceRequisition.vue?vue&type=script&lang=js"
export * from "./ServiceRequisition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13b806",
  null
  
)

export default component.exports